import React from 'react';
import Documentation from '../components/Help/Documentation';

const HelpPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Documentation />
      </div>
    </div>
  );
};

export default HelpPage;
